import React from "react"
import DOMPurify from "dompurify"

interface RenderHtmlProps {
  htmlContent: string
  className?: string
}

export const RenderHtml: React.FC<RenderHtmlProps> = ({
  htmlContent,
  className = "",
}) => {
  React.useEffect(() => {
    // Configure DOMPurify to allow iframe elements for embedded videos
    DOMPurify.addHook("uponSanitizeElement", (node, data) => {
      if (data.tagName === "iframe") {
        // Allow YouTube and other common video embeds
        // Use type assertion to treat node as HTMLElement
        const element = node as HTMLElement
        const src = element.getAttribute("src") || ""
        if (
          src.includes("youtube.com") ||
          src.includes("youtu.be") ||
          src.includes("vimeo.com") ||
          src.includes("dailymotion.com")
        ) {
          // These attributes are needed for proper iframe functioning
          element.setAttribute("allowfullscreen", "true")
          element.setAttribute("frameborder", "0")
        }
      }
    })

    return () => {
      // Clean up the hook when component unmounts
      DOMPurify.removeHook("uponSanitizeElement")
    }
  }, [])

  // Set up DOMPurify configuration
  const sanitizeConfig = {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: [
      "allowfullscreen",
      "frameborder",
      "allow",
      "src",
      "style",
      "class",
      "target",
    ],
  }

  // Sanitize the HTML with our configuration
  const sanitizedHtml = DOMPurify.sanitize(htmlContent, sanitizeConfig)

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  )
}
